import { formatPercentage } from '../../../lib';

export const RedTag= ({percentage}) => {
    let result = formatPercentage(percentage)
    return(
        <span className="tag red"> {result}% </span>
    )
}
